import React, { useReducer, useEffect, useState, useCallback } from "react";
import { sendContactEmail } from "../services/emailService";
import jsPDF from "jspdf";
import "./Contacto.css";

const initialState = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
  selectedApp: "",
};

const formReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      return { ...state, [action.field]: action.value };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

const aplicacionesDisponibles = [
  "Gestión Sage 200",
  "Finanzas Sage 200",
  "Proyectos Sage 200",
  "Producción Sage 200",
  "App Partes",
  "App Josemite",
  "App Compras",
  "App Validador",
];

const ContactPage = () => {
  const [formData, dispatch] = useReducer(formReducer, initialState);
  const [showAppSelect, setShowAppSelect] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setShowAppSelect(formData.subject === "Solicitar una demostración");
    if (formData.subject !== "Solicitar una demostración") {
      dispatch({ type: "UPDATE_FIELD", field: "selectedApp", value: "" });
    }
  }, [formData.subject]);

  const handleChange = useCallback((e) => {
    dispatch({ type: "UPDATE_FIELD", field: e.target.name, value: e.target.value });
  }, []);

  const validateForm = () => {
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setStatusMessage({ type: "error", text: "Por favor, completa todos los campos obligatorios." });
      return false;
    }
    return true;
  };

  const generarPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Formulario de Contacto", 10, 20);

    doc.setFontSize(12);
    doc.text(`Nombre: ${formData.name}`, 10, 30);
    doc.text(`Email: ${formData.email}`, 10, 40);
    doc.text(`Teléfono: ${formData.phone || "No especificado"}`, 10, 50);
    doc.text(`Motivo: ${formData.subject}`, 10, 60);
    doc.text(`Aplicación de interés: ${formData.selectedApp || "No especificada"}`, 10, 70);
    doc.text(`Mensaje: ${formData.message}`, 10, 80);

    doc.save("formulario_contacto.pdf");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      await sendContactEmail(
        formData.name,
        formData.email,
        formData.phone,
        formData.subject,
        formData.message,
        formData.selectedApp || "No especificada"
      );

      setStatusMessage({ type: "success", text: "Mensaje enviado correctamente." });
      generarPDF(); // Generar y descargar el PDF
      dispatch({ type: "RESET" });

      setTimeout(() => setStatusMessage({ type: "", text: "" }), 3000);
    } catch (error) {
      setStatusMessage({ type: "error", text: "Error al enviar el mensaje. Inténtalo de nuevo." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contacto">
      <div className="contacto-background">
        <img src="/images/contactobackground.jpg" alt="Imagen de fondo de contacto" />
      </div>

      <div className="contacto-overlay"></div>

      <div className="contacto-container">
        <h1>Formulario de Contacto</h1>

        {statusMessage.text && (
          <p className={statusMessage.type === "success" ? "success-message" : "error-message"}>
            {statusMessage.text}
          </p>
        )}

        {loading && <p className="loading-message">Enviando...</p>}

        <form onSubmit={handleSubmit} className="contacto-form">
          <label htmlFor="name">Nombre:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label htmlFor="phone">Teléfono:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />

          <label htmlFor="subject">Motivo:</label>
          <select
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un motivo</option>
            <option value="Consulta general">Consulta general</option>
            <option value="Solicitar una demostración">Solicitar una demostración</option>
          </select>

          {showAppSelect && (
            <>
              <label htmlFor="selectedApp">Aplicación de interés:</label>
              <select
                id="selectedApp"
                name="selectedApp"
                value={formData.selectedApp}
                onChange={handleChange}
                required
              >
                <option value="">Selecciona una aplicación</option>
                {aplicacionesDisponibles.map((app) => (
                  <option key={app} value={app}>
                    {app}
                  </option>
                ))}
              </select>
            </>
          )}

          <label htmlFor="message">Mensaje:</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" disabled={loading}>Enviar</button>
        </form>
      </div>
    </div>
  );
};

export default ContactPage;